import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
    mapStateToProps as sourceMapStateToProps,
    ProductListContainer as SourceProductListContainer
} from 'SourceComponent/ProductList/ProductList.container';
import { scrollToTop } from 'Util/Browser';

export const ProductListInfoDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/ProductListInfo/ProductListInfo.dispatcher'
);

/** @namespace Elganso/Component/ProductList/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // TODO extend mapStateToProps
});

/** @namespace Elganso/Component/ProductList/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    requestProductListInfo: (options) => ProductListInfoDispatcher.then(
        ({ default: dispatcher }) => dispatcher.handleData(dispatch, options)
    )
});

/** @namespace Elganso/Component/ProductList/Container */
export class ProductListContainer extends SourceProductListContainer {
    containerProps() {
        const {
            valueColumn,
            pageSize
        } = this.props;

        return {
            ...super.containerProps(),
            valueColumn,
            pageSize
        };
    }

    _getIsInfiniteLoaderEnabled() {
        const { isInfiniteLoaderEnabled } = this.props;

        return isInfiniteLoaderEnabled;
    }

    requestPage(currentPage = 1, isNext = false) {
        const {
            sort,
            search,
            filter,
            pageSize,
            requestProductList,
            requestProductListInfo,
            noAttributes,
            noVariants,
            isWidget,
            device
        } = this.props;

        /**
         * In case the wrong category was passed down to the product list,
         * prevent it from being requested.
         */
        if (filter.categoryIds === -1) {
            return;
        }

        /**
         * Do not request page if there are no filters
         */
        if (!search && !this.isEmptyFilter()) {
            return;
        }

        // TODO: product list requests filters alongside the page
        // TODO: sometimes product list is requested more then once
        // TODO: the product list should not request itself, when coming from PDP

        const options = {
            isNext,
            noAttributes,
            noVariants,
            args: {
                sort,
                filter,
                search,
                pageSize,
                currentPage
            }
        };

        const infoOptions = {
            args: {
                filter,
                search
            }
        };

        requestProductList(options);

        if (!isWidget) {
            requestProductListInfo(infoOptions);

            if (!device.isMobile && filter.length > 0) {
                scrollToTop();
            }
        }
    }

    loadPage(next = true) {
        const { pagesCount } = this.state;
        const { isPageLoading } = this.props;

        if (!isPageLoading) {
            const {
                minPage,
                maxPage,
                totalPages,
                loadedPagesCount
            } = this._getPagesBounds();

            const isUpdatable = totalPages > 0 && pagesCount === loadedPagesCount;
            const shouldUpdateList = next ? maxPage < totalPages : minPage > 1;

            if (isUpdatable && shouldUpdateList) {
                this.setState({ pagesCount: pagesCount + 1 });
                this.requestPage(next ? maxPage + 1 : minPage - 1, true);
            }
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductListContainer));
